import React from 'react';
import { Button, Form, Input, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import './CartaForm.scss';
import { dummyRequest, normFile } from '../../../utils/upload';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

const CartaForm = () => {
  return <div className="CartaForm">

    <h4>Capa</h4>
    <div className="line">
      <Form.Item
        name="carta_imagem1"
        label="Imagem 1"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={[{ required: true, message: 'Campo obrigatório!' }]}
      >
        <Upload
          name="carta_imagem1"
          customRequest={dummyRequest}
          accept=".jpg,.jpeg,.png,.gif"
          listType="picture"
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>Selecionar Imagem</Button>
        </Upload>
      </Form.Item>
    </div>

    <Form.List name="carta_itens">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <>
              <h4>Página {key + 2}</h4>
              <div className="line"
                key={key}
                align="baseline"
              >



                <Form.Item
                  {...restField}
                  name={[name, 'carta_imagem']}
                  label={`Imagem ${key + 2}`}
                  valuePropName="fileList"
                  getValueFromEvent={normFile}
                  rules={[{ required: true, message: 'Campo obrigatório!' }]}
                >
                  <Upload
                    name={[name, 'carta_imagem']}
                    customRequest={dummyRequest}
                    accept=".jpg,.jpeg,.png,.gif"
                    listType="picture"
                    maxCount={1}
                  >
                    <Button icon={<UploadOutlined />}>Selecionar Imagem</Button>
                  </Upload>
                </Form.Item>

                <Form.Item
                  {...restField}
                  name={[name, 'carta_qrcode_x']}
                  label="QRCode posição horizontal"
                  rules={[{ required: true, message: 'Campo obrigatório!' }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  {...restField}
                  name={[name, 'carta_qrcode_y']}
                  label="QRCode posição vertical"
                  rules={[{ required: true, message: 'Campo obrigatório!' }]}
                >
                  <Input />
                </Form.Item>



                <MinusCircleOutlined onClick={() => remove(name)} />
              </div>
            </>
          ))}


          <Form.Item>
            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
              Adicionar item
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>

    <h4>Última</h4>
    <div className="line">
      <Form.Item
        name="carta_ultima"
        label="Última"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={[{ required: true, message: 'Campo obrigatório!' }]}
      >
        <Upload
          name="carta_ultima"
          customRequest={dummyRequest}
          accept=".jpg,.jpeg,.png,.gif"
          listType="picture"
          maxCount={1}
        >
          <Button icon={<UploadOutlined />}>Selecionar Imagem</Button>
        </Upload>
      </Form.Item>

      <Form.Item
        name="carta_qrcode_ultima_x"
        label="QRCode posição horizontal"
        rules={[{ required: true, message: 'Campo obrigatório!' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="carta_qrcode_ultima_y"
        label="QRCode posição vertical"
        rules={[{ required: true, message: 'Campo obrigatório!' }]}
      >
        <Input />
      </Form.Item>
    </div>

  </div>
};
export default CartaForm;